import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

import parse from 'html-react-parser';

import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import { reqGET, translate } from '../../../../Utils';

import Loader from '../../../Loader/Loader';

import { language } from './Language';

import {api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const dados = useRef(null);

    const { pathname } = useLocation();

    const [data, set_data] = useState(data_interface);

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        // await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
        let res = await reqGET(`${api_crud_route}/type/${getTokenInfo().companycode}/license_crm`)
        if(Array.isArray(res.data) && res.data.length > 0) {
            set_data(res.data[0])
            set_dados(dados.current = res.data[0])
            console.log('res.data', res.data)
            console.log('dados.current', dados.current)
        }
        else {
            set_dados(dados.current = data_interface)
        }
    }
    
    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if(permissions.current !== null) {
                                aux = permissions.current

                                if(aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if(aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if(aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {
                    
                    let aux = {}
                    if(permissions.current !== null) {
                        aux = permissions.current

                        if(aux.create !== true) {
                            aux.create = node.create
                        }
                        if(aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if(aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }
                    
                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if(Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await fetchInfo('')

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if(getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    return isloading ?
            <Loader />
        :
            <main>

                <div className={`dash-cards header d-none`}>
                    <div className="container">
                        <h2 className="dash-title">{translate(dados.current.content[0].title, lang)}</h2>
                    </div>
                </div>

                <div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="col-12 col-md-8 mb-5 mb-xl-10 mx-auto mt-5">

                                <div className="card-body bg-white p-5">
                                    <div className="row mb-4 p-5">

                                        <div className="col-12 pb-5 text-center">
                                            <h3>{language[lang].license_title}</h3>
                                        </div>

                                        <div className="col-12 pb-5 text-center">
                                            <p>{language[lang].license_msg}</p>
                                        </div>

                                        <div className="col-12 pb-5 text-center">
                                            <p>
                                                <strong>{dados.current.info.client}</strong>
                                                {
                                                permissions?.current?.edit !== undefined && permissions.current.edit === true ?
                                                    <Link className="button button-update ms-3 text-dark" to={{ pathname: endpoints.regist, state: { item: data, operation: 'edit' } }} replace>
                                                        <i className="bi bi-pencil"></i>
                                                    </Link>
                                                :
                                                    null
                                                }  
                                            </p>
                                        </div>

                                        <div className="col-12 pb-5 text-center">
                                            <table className='table table-striped'>
                                                <thead>
                                                    <tr>
                                                        <th>{language[lang].license_table_software}</th>
                                                        <th>{language[lang].version}</th>
                                                        <th>{language[lang].serie}</th>
                                                        <th>{language[lang].qtd}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{dados.current.info.software}<br />({dados.current.info.users} {language[lang].users})</td>
                                                        <td>{dados.current.info.version}</td>
                                                        <td>{dados.current.info.serie}</td>
                                                        <td>{dados.current.info.qtd}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-12 pt-5 mt-5 text-center">
                                            <p><strong>{language[lang].license_date_begin}:</strong> {dados.current.info.license_date_begin} { dados.current.info.license_date_end !== undefined && dados.current.info.license_date_end !== '' ? ' ' + language[lang].license_date_to + ' ' + dados.current.info.license_date_end : ''}</p>
                                        </div>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </main>
}